'use strict';

var novicell = novicell || {};

novicell.filterSection = novicell.filterSection || new function () {
    const filterDropdDownActiveClass = 'filter-section-dropdown--active';

    this.init = function (data) {
        var filterDropdownTriggers = document.querySelectorAll('.js-filter-section-dropdown-trigger');

        if (!filterDropdownTriggers) {
            return;
        }

        for (var i = 0; i < filterDropdownTriggers.length; i++) {
            let currentTrigger = filterDropdownTriggers[i];

            currentTrigger.addEventListener('click', function () {
                var element = event.target.parentElement;

                if (novicell.helper.hasClass(element, filterDropdDownActiveClass)) {
                    closeAll();
                } else {
                    closeAll();
                    element.classList.add(filterDropdDownActiveClass);
                    clickedOutside(element);
                    document.addEventListener('keydown', handleEsc, true);
                }
            });
        }
        setThemeClass();
    };

    function clickedOutside(element) {

        // add click event to document
        document.addEventListener('click', function (event) {
            // check if item is open
            if (novicell.helper.hasClass(element, filterDropdDownActiveClass)) {
                let newTarget = element.contains(event.target);
                if (!newTarget) {
                    closeAll();
                }
            }
        });
    }

    function handleEsc(e) {
        if (e.keyCode === 27) {
            closeAll();
        }
    }

    function closeAll(element) {

        // find all and remove active
        let classHolder = document.getElementsByClassName('filter-section-dropdown');

        for (let y = 0; y < classHolder.length; y++) {
            let currentElement = classHolder[y];
            currentElement.classList.remove(filterDropdDownActiveClass);
        }
        document.removeEventListener('keydown', handleEsc, true);
    }

    // Background color on filters
    function setThemeClass() {
        let listHolder = document.querySelectorAll('.circe-font .filter-section ~ .list, .circe-font .grid-section--listpage .list');//[class~=" theme-"]

        if(listHolder) {
            for (let i = 0; i < listHolder.length; i++) {
                let currentElement = listHolder[i];
                if(currentElement.classList.contains("theme-1")) {
                    setClasses(currentElement, "1");
                }
                else if(currentElement.classList.contains("theme-2")) {
                    setClasses(currentElement, "2");
                }
                else if(currentElement.classList.contains("theme-3")) {
                    setClasses(currentElement, "3");
                }
                else if(currentElement.classList.contains("theme-4")) {
                    setClasses(currentElement, "4"); 
                }
                else if(currentElement.classList.contains("theme-5")) {
                    setClasses(currentElement, "5");
                }
                else if(currentElement.classList.contains("theme-6")) {
                    setClasses(currentElement, "6");
                }
                else if(currentElement.classList.contains("theme-7")) {
                    setClasses(currentElement, "7");
                }
                else if(currentElement.classList.contains("theme-8")) {
                    setClasses(currentElement, "8");
                }
                else {
                    setClasses(currentElement, "0");
                }
            }
        }
    }

    function setClasses(current, themeNumber) {
        let filterSection = current;
        let parentGridSection = filterSection.closest('.grid-section');
        let parentContainer = filterSection.closest('.container');
        parentGridSection.classList.add('filter-theme-' + themeNumber);
        parentContainer.classList.add('container--has-theme');
    }
}();